"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _misc = require("HubStyleTokens/misc");

var _component = _interopRequireDefault(require("../utils/propTypes/component"));

var _decorators = require("../utils/propTypes/decorators");

var _Styles = require("../utils/Styles");

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  ", ";\n  ", ";\n  display: block;\n  line-height: normal;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Heading = (0, _styledComponents.default)(function (props) {
  var Tag = props.tagName,
      rest = (0, _objectWithoutProperties2.default)(props, ["tagName"]);
  return _react.default.createElement(Tag, rest);
}).attrs({
  role: 'heading'
}).withConfig({
  displayName: "Heading",
  componentId: "ijg3cf-0"
})(_templateObject(), (0, _Styles.setFontSmoothing)(_misc.HEADING_FONT_SMOOTHING), (0, _Styles.singleDirectionModuleSpacing)());
Heading.propTypes = {
  'aria-level': _react.PropTypes.oneOf([1, 2, 3, 4, 5, 6]),
  tagName: (0, _decorators.hidden)(_component.default.isRequired)
};
Heading.defaultProps = {
  'aria-level': 2,
  tagName: 'span'
};
var _default = Heading;
exports.default = _default;
module.exports = exports.default;